/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, metric: NonNullable<unknown>, rightChain: NonNullable<unknown> }} Chain_Page_Compare_Time_SameInputs */



/**
* | output |
* | --- |
* | "{leftChain} {metric} is the same as {rightChain} {metric}" |
*
* @param {Chain_Page_Compare_Time_SameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_time_same = /** @type {((inputs: Chain_Page_Compare_Time_SameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Time_SameInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} ${i?.metric} is the same as ${i?.rightChain} ${i?.metric}`)
});